import type { components } from "@dolfin/api-public";

type BillState = components["schemas"]["BillState"];
type MatchGroupStatus = components["schemas"]["MatchGroupStatus"];

export function stateVariant(
  state: BillState | undefined,
): "default" | "secondary" | "outline" | "destructive" {
  switch (state) {
    case "Approved":
    case "Paid":
      return "default";
    case "PendingReview":
    case "NeedsApproval":
    case "PartiallyPaid":
      return "secondary";
    case "Rejected":
    case "ExtractionFailed":
    case "OcrFailed": // obsolete alias, retained for in-flight bills during the rename drain
    case "PaymentFailed":
    case "Voided":
      return "destructive";
    default:
      return "outline";
  }
}

export function stateLabel(state: BillState | undefined): string {
  switch (state) {
    case "Extracting":
      return "Extracting";
    case "OcrProcessing": // obsolete alias, retained for in-flight bills during the rename drain
      return "Extracting";
    case "PendingReview":
      return "Pending Review";
    case "NeedsApproval":
      return "Needs Approval";
    case "ExtractionFailed":
      return "Extraction Failed";
    case "OcrFailed": // obsolete alias, retained for in-flight bills during the rename drain
      return "Extraction Failed";
    case "PaymentInProgress":
      return "Payment in Progress";
    case "PaymentFailed":
      return "Payment Failed";
    case "PartiallyPaid":
      return "Partially Paid";
    default:
      return state ?? "Unknown";
  }
}

// A null matchSummary means no match group at all (no candidate PO), which is NOT Open (group exists, nothing
// allocated). Callers handle it: "unmatched" for both would imply work where there is none.
export function matchStatusVariant(
  status: MatchGroupStatus,
): "default" | "secondary" | "outline" | "destructive" {
  switch (status) {
    // Variance is the only status that demands a human decision, so it's the only one that gets shouted at.
    case "Variance":
      return "destructive";
    case "Resolved":
    case "Synced":
      return "default";
    default:
      return "secondary";
  }
}

export function matchStatusLabel(status: MatchGroupStatus): string {
  switch (status) {
    case "Open":
      return "Unmatched";
    case "Variance":
      return "Variance";
    case "Resolved":
      return "Matched";
    case "Synced":
      return "Synced";
    default:
      return status;
  }
}
